import * as actionTypes from "./actionsTypes";

export const clearState = () => {
    return {
        type: actionTypes.CLEAR_STATE
    }
};